/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface CredentialsService {
  /**
   * @summary Create Credentials
   * @description Creates a new credentials.
   */
  createCredentialsCredentialsPost: {
    /**
     * @summary Create Credentials
     * @description Creates a new credentials.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateCredentialsCredentialsPostBody,
        CreateCredentialsCredentialsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateCredentialsCredentialsPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateCredentialsCredentialsPostBody,
          CreateCredentialsCredentialsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateCredentialsCredentialsPostData, CreateCredentialsCredentialsPostError>>
    ): Promise<RequestFnResponse<CreateCredentialsCredentialsPostData, CreateCredentialsCredentialsPostError>>;
    /**
     * @summary Create Credentials
     * @description Creates a new credentials.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateCredentialsCredentialsPostParameters> | void
    ): ServiceOperationMutationKey<CreateCredentialsCredentialsPostSchema, CreateCredentialsCredentialsPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Credentials
     * @description Creates a new credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.createCredentialsCredentialsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.createCredentialsCredentialsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateCredentialsCredentialsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateCredentialsCredentialsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateCredentialsCredentialsPostSchema,
        CreateCredentialsCredentialsPostData,
        CreateCredentialsCredentialsPostParameters,
        TVariables,
        OperationError<CreateCredentialsCredentialsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateCredentialsCredentialsPostData,
      OperationError<CreateCredentialsCredentialsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Credentials
     * @description Creates a new credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.createCredentialsCredentialsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.createCredentialsCredentialsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateCredentialsCredentialsPostBody,
        CreateCredentialsCredentialsPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateCredentialsCredentialsPostSchema,
        CreateCredentialsCredentialsPostData,
        CreateCredentialsCredentialsPostParameters,
        TVariables,
        OperationError<CreateCredentialsCredentialsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateCredentialsCredentialsPostData,
      OperationError<CreateCredentialsCredentialsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Credentials
     * @description Creates a new credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createCredentialsCredentialsPostTotal = qraft.credentialsService.createCredentialsCredentialsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createCredentialsCredentialsPostTotal = qraft.credentialsService.createCredentialsCredentialsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateCredentialsCredentialsPostBody,
            CreateCredentialsCredentialsPostData,
            CreateCredentialsCredentialsPostParameters,
            OperationError<CreateCredentialsCredentialsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCredentialsCredentialsPostSchema,
            CreateCredentialsCredentialsPostBody,
            CreateCredentialsCredentialsPostData,
            CreateCredentialsCredentialsPostParameters,
            OperationError<CreateCredentialsCredentialsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Credentials
     * @description Creates a new credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createCredentialsCredentialsPostPendingMutationVariables = qraft.credentialsService.createCredentialsCredentialsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createCredentialsCredentialsPostMutationData = qraft.credentialsService.createCredentialsCredentialsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateCredentialsCredentialsPostData,
        OperationError<CreateCredentialsCredentialsPostError>,
        MutationVariables<CreateCredentialsCredentialsPostBody, CreateCredentialsCredentialsPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateCredentialsCredentialsPostBody,
            CreateCredentialsCredentialsPostData,
            CreateCredentialsCredentialsPostParameters,
            OperationError<CreateCredentialsCredentialsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCredentialsCredentialsPostSchema,
            CreateCredentialsCredentialsPostBody,
            CreateCredentialsCredentialsPostData,
            CreateCredentialsCredentialsPostParameters,
            OperationError<CreateCredentialsCredentialsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateCredentialsCredentialsPostData,
          OperationError<CreateCredentialsCredentialsPostError>,
          MutationVariables<CreateCredentialsCredentialsPostBody, CreateCredentialsCredentialsPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Credentials
     * @description Creates a new credentials.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateCredentialsCredentialsPostBody,
            CreateCredentialsCredentialsPostData,
            CreateCredentialsCredentialsPostParameters,
            OperationError<CreateCredentialsCredentialsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCredentialsCredentialsPostSchema,
            CreateCredentialsCredentialsPostBody,
            CreateCredentialsCredentialsPostData,
            CreateCredentialsCredentialsPostParameters,
            OperationError<CreateCredentialsCredentialsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Credentials
     * @description Creates a new credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.credentialsService.createCredentialsCredentialsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.credentialsService.createCredentialsCredentialsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateCredentialsCredentialsPostBody,
              CreateCredentialsCredentialsPostData,
              CreateCredentialsCredentialsPostParameters,
              OperationError<CreateCredentialsCredentialsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateCredentialsCredentialsPostSchema,
              CreateCredentialsCredentialsPostBody,
              CreateCredentialsCredentialsPostData,
              CreateCredentialsCredentialsPostParameters,
              OperationError<CreateCredentialsCredentialsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateCredentialsCredentialsPostData,
            CreateCredentialsCredentialsPostError,
            MutationVariables<CreateCredentialsCredentialsPostBody, CreateCredentialsCredentialsPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateCredentialsCredentialsPostBody,
              CreateCredentialsCredentialsPostData,
              CreateCredentialsCredentialsPostParameters,
              OperationError<CreateCredentialsCredentialsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateCredentialsCredentialsPostSchema,
              CreateCredentialsCredentialsPostBody,
              CreateCredentialsCredentialsPostData,
              CreateCredentialsCredentialsPostParameters,
              OperationError<CreateCredentialsCredentialsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateCredentialsCredentialsPostData,
          CreateCredentialsCredentialsPostError,
          MutationVariables<CreateCredentialsCredentialsPostBody, CreateCredentialsCredentialsPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateCredentialsCredentialsPostSchema;
    types: {
      parameters: CreateCredentialsCredentialsPostParameters;
      data: CreateCredentialsCredentialsPostData;
      error: CreateCredentialsCredentialsPostError;
      body: CreateCredentialsCredentialsPostBody;
    };
  };
  /**
   * @summary Get All Credentialss
   * @description Retrieves a list of credentials with pagination.
   */
  getAllCredentialssCredentialsGet: {
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetAllCredentialssCredentialsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllCredentialssCredentialsGetSchema,
        options: {
          parameters: GetAllCredentialssCredentialsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetError>>
    ): Promise<RequestFnResponse<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetError>>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    getQueryKey(
      parameters: DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void
    ): ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.credentialsService.getAllCredentialssCredentialsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.credentialsService.getAllCredentialssCredentialsGet.useQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllCredentialssCredentialsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllCredentialssCredentialsGetData,
          GetAllCredentialssCredentialsGetError,
          TData,
          ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllCredentialssCredentialsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.credentialsService.getAllCredentialssCredentialsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.credentialsService.getAllCredentialssCredentialsGet.useQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllCredentialssCredentialsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllCredentialssCredentialsGetData,
          GetAllCredentialssCredentialsGetError,
          TData,
          ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllCredentialssCredentialsGetError>>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      GetAllCredentialssCredentialsGetSchema,
      GetAllCredentialssCredentialsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.credentialsService.getAllCredentialssCredentialsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllCredentialssCredentialsGetParameters,
      TQueryFnData = GetAllCredentialssCredentialsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllCredentialssCredentialsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllCredentialssCredentialsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllCredentialssCredentialsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.credentialsService.getAllCredentialssCredentialsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllCredentialssCredentialsGetParameters,
      TQueryFnData = GetAllCredentialssCredentialsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllCredentialssCredentialsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllCredentialssCredentialsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAllCredentialssCredentialsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllCredentialssCredentialsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllCredentialssCredentialsGetTotal = qraft.credentialsService.getAllCredentialssCredentialsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAllCredentialssCredentialsGetByParametersTotal = qraft.credentialsService.getAllCredentialssCredentialsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             skip: skip
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllCredentialssCredentialsGetResults = qraft.credentialsService.getAllCredentialssCredentialsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllCredentialssCredentialsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllCredentialssCredentialsGetCombinedResults = qraft.credentialsService.getAllCredentialssCredentialsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllCredentialssCredentialsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllCredentialssCredentialsGetSchema,
          GetAllCredentialssCredentialsGetParameters,
          GetAllCredentialssCredentialsGetData,
          GetAllCredentialssCredentialsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.credentialsService.getAllCredentialssCredentialsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.credentialsService.getAllCredentialssCredentialsGet.useSuspenseQuery({
     *     query: {
     *         skip: skip
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAllCredentialssCredentialsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllCredentialssCredentialsGetData,
          GetAllCredentialssCredentialsGetError,
          TData,
          ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllCredentialssCredentialsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.credentialsService.getAllCredentialssCredentialsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             skip: initialSkip
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllCredentialssCredentialsGetParameters,
      TData = GetAllCredentialssCredentialsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllCredentialssCredentialsGetData,
          GetAllCredentialssCredentialsGetError,
          OperationInfiniteData<TData, GetAllCredentialssCredentialsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAllCredentialssCredentialsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllCredentialssCredentialsGetParameters>,
      OperationError<GetAllCredentialssCredentialsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllCredentialssCredentialsGetData = qraft.credentialsService.getAllCredentialssCredentialsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllCredentialssCredentialsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllCredentialssCredentialsGetCombinedData = qraft.credentialsService.getAllCredentialssCredentialsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 skip: skip1
     *             }
     *         },
     *         {
     *             query: {
     *                 skip: skip2
     *             }
     *         }
     *     ]
     * });
     * getAllCredentialssCredentialsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllCredentialssCredentialsGetSchema,
          GetAllCredentialssCredentialsGetParameters,
          GetAllCredentialssCredentialsGetData,
          GetAllCredentialssCredentialsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllCredentialssCredentialsGetSchema,
        GetAllCredentialssCredentialsGetData,
        GetAllCredentialssCredentialsGetParameters,
        GetAllCredentialssCredentialsGetError
      > | void
    ): Promise<GetAllCredentialssCredentialsGetData>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllCredentialssCredentialsGetSchema,
        GetAllCredentialssCredentialsGetData,
        GetAllCredentialssCredentialsGetParameters,
        GetAllCredentialssCredentialsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllCredentialssCredentialsGetSchema,
        GetAllCredentialssCredentialsGetData,
        GetAllCredentialssCredentialsGetParameters,
        GetAllCredentialssCredentialsGetError
      > | void
    ): Promise<GetAllCredentialssCredentialsGetData>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    fetchInfiniteQuery<TPageParam extends GetAllCredentialssCredentialsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllCredentialssCredentialsGetSchema,
        GetAllCredentialssCredentialsGetData,
        GetAllCredentialssCredentialsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllCredentialssCredentialsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetParameters>>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    prefetchInfiniteQuery<TPageParam extends GetAllCredentialssCredentialsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllCredentialssCredentialsGetSchema,
        GetAllCredentialssCredentialsGetData,
        GetAllCredentialssCredentialsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllCredentialssCredentialsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    ensureInfiniteQueryData<TPageParam extends GetAllCredentialssCredentialsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllCredentialssCredentialsGetSchema,
        GetAllCredentialssCredentialsGetData,
        GetAllCredentialssCredentialsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllCredentialssCredentialsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetParameters>>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void)
    ): GetAllCredentialssCredentialsGetData | undefined;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void)
    ):
      | OperationInfiniteData<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetParameters>
      | undefined;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllCredentialssCredentialsGetSchema,
              GetAllCredentialssCredentialsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetAllCredentialssCredentialsGetData,
                    GetAllCredentialssCredentialsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllCredentialssCredentialsGetSchema,
              GetAllCredentialssCredentialsGetParameters
            >,
            data: GetAllCredentialssCredentialsGetData | undefined,
          ]
        >;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | void)
    ): QueryState<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetError> | undefined;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllCredentialssCredentialsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetParameters>,
          GetAllCredentialssCredentialsGetError
        >
      | undefined;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllCredentialssCredentialsGetSchema, GetAllCredentialssCredentialsGetParameters>,
      updater: Updater<
        NoInfer<GetAllCredentialssCredentialsGetData> | undefined,
        NoInfer<DeepReadonly<GetAllCredentialssCredentialsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllCredentialssCredentialsGetData | undefined;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllCredentialssCredentialsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetAllCredentialssCredentialsGetData, GetAllCredentialssCredentialsGetParameters>
      | undefined;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >,
      updater: Updater<
        NoInfer<GetAllCredentialssCredentialsGetData> | undefined,
        NoInfer<GetAllCredentialssCredentialsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllCredentialssCredentialsGetData | undefined>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllCredentialssCredentialsGetSchema,
        GetAllCredentialssCredentialsGetData,
        TInfinite,
        GetAllCredentialssCredentialsGetParameters,
        GetAllCredentialssCredentialsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
    ): void;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get All Credentialss
     * @description Retrieves a list of credentials with pagination.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllCredentialssCredentialsGetSchema,
            GetAllCredentialssCredentialsGetData,
            TInfinite,
            GetAllCredentialssCredentialsGetParameters,
            GetAllCredentialssCredentialsGetError
          >
    ): number;
    schema: GetAllCredentialssCredentialsGetSchema;
    types: {
      parameters: GetAllCredentialssCredentialsGetParameters;
      data: GetAllCredentialssCredentialsGetData;
      error: GetAllCredentialssCredentialsGetError;
    };
  };
  /**
   * @summary Get Credentials
   * @description Retrieves a single credentials by its ID.
   */
  getCredentialsCredentialsCredentialIdGet: {
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetCredentialsCredentialsCredentialIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetCredentialsCredentialsCredentialIdGetSchema,
        options: {
          parameters: GetCredentialsCredentialsCredentialIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetCredentialsCredentialsCredentialIdGetData, GetCredentialsCredentialsCredentialIdGetError>
      >
    ): Promise<
      RequestFnResponse<GetCredentialsCredentialsCredentialIdGetData, GetCredentialsCredentialsCredentialIdGetError>
    >;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>
    ): ServiceOperationQueryKey<
      GetCredentialsCredentialsCredentialIdGetSchema,
      GetCredentialsCredentialsCredentialIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useQuery({
     *     path: {
     *         credential_id: credentialId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCredentialsCredentialsCredentialIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCredentialsCredentialsCredentialIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useQuery({
     *     path: {
     *         credential_id: credentialId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCredentialsCredentialsCredentialIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCredentialsCredentialsCredentialIdGetError>>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetCredentialsCredentialsCredentialIdGetSchema,
      GetCredentialsCredentialsCredentialIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useInfiniteQuery({
     *     path: {
     *         credential_id: credentialId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCredentialsCredentialsCredentialIdGetParameters,
      TQueryFnData = GetCredentialsCredentialsCredentialIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCredentialsCredentialsCredentialIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCredentialsCredentialsCredentialIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCredentialsCredentialsCredentialIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useInfiniteQuery({
     *     path: {
     *         credential_id: credentialId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCredentialsCredentialsCredentialIdGetParameters,
      TQueryFnData = GetCredentialsCredentialsCredentialIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCredentialsCredentialsCredentialIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCredentialsCredentialsCredentialIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCredentialsCredentialsCredentialIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetCredentialsCredentialsCredentialIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCredentialsCredentialsCredentialIdGetTotal = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getCredentialsCredentialsCredentialIdGetByParametersTotal = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             credential_id: credentialId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCredentialsCredentialsCredentialIdGetResults = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 credential_id: credentialId1
     *             }
     *         },
     *         {
     *             path: {
     *                 credential_id: credentialId2
     *             }
     *         }
     *     ]
     * });
     * getCredentialsCredentialsCredentialIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCredentialsCredentialsCredentialIdGetCombinedResults = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 credential_id: credentialId1
     *             }
     *         },
     *         {
     *             path: {
     *                 credential_id: credentialId2
     *             }
     *         }
     *     ]
     * });
     * getCredentialsCredentialsCredentialIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCredentialsCredentialsCredentialIdGetSchema,
          GetCredentialsCredentialsCredentialIdGetParameters,
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetCredentialsCredentialsCredentialIdGetData, GetCredentialsCredentialsCredentialIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetCredentialsCredentialsCredentialIdGetData, GetCredentialsCredentialsCredentialIdGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useSuspenseQuery({
     *     path: {
     *         credential_id: credentialId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetCredentialsCredentialsCredentialIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCredentialsCredentialsCredentialIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         credential_id: credentialId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetCredentialsCredentialsCredentialIdGetParameters,
      TData = GetCredentialsCredentialsCredentialIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetError,
          OperationInfiniteData<TData, GetCredentialsCredentialsCredentialIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCredentialsCredentialsCredentialIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCredentialsCredentialsCredentialIdGetParameters>,
      OperationError<GetCredentialsCredentialsCredentialIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCredentialsCredentialsCredentialIdGetData = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 credential_id: credentialId1
     *             }
     *         },
     *         {
     *             path: {
     *                 credential_id: credentialId2
     *             }
     *         }
     *     ]
     * });
     * getCredentialsCredentialsCredentialIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCredentialsCredentialsCredentialIdGetCombinedData = qraft.credentialsService.getCredentialsCredentialsCredentialIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 credential_id: credentialId1
     *             }
     *         },
     *         {
     *             path: {
     *                 credential_id: credentialId2
     *             }
     *         }
     *     ]
     * });
     * getCredentialsCredentialsCredentialIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCredentialsCredentialsCredentialIdGetSchema,
          GetCredentialsCredentialsCredentialIdGetParameters,
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetCredentialsCredentialsCredentialIdGetData,
              GetCredentialsCredentialsCredentialIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCredentialsCredentialsCredentialIdGetSchema,
        GetCredentialsCredentialsCredentialIdGetData,
        GetCredentialsCredentialsCredentialIdGetParameters,
        GetCredentialsCredentialsCredentialIdGetError
      >
    ): Promise<GetCredentialsCredentialsCredentialIdGetData>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCredentialsCredentialsCredentialIdGetSchema,
        GetCredentialsCredentialsCredentialIdGetData,
        GetCredentialsCredentialsCredentialIdGetParameters,
        GetCredentialsCredentialsCredentialIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCredentialsCredentialsCredentialIdGetSchema,
        GetCredentialsCredentialsCredentialIdGetData,
        GetCredentialsCredentialsCredentialIdGetParameters,
        GetCredentialsCredentialsCredentialIdGetError
      >
    ): Promise<GetCredentialsCredentialsCredentialIdGetData>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    fetchInfiniteQuery<TPageParam extends GetCredentialsCredentialsCredentialIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCredentialsCredentialsCredentialIdGetSchema,
        GetCredentialsCredentialsCredentialIdGetData,
        GetCredentialsCredentialsCredentialIdGetParameters,
        DeepReadonly<TPageParam>,
        GetCredentialsCredentialsCredentialIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCredentialsCredentialsCredentialIdGetData,
        GetCredentialsCredentialsCredentialIdGetParameters
      >
    >;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetCredentialsCredentialsCredentialIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCredentialsCredentialsCredentialIdGetSchema,
        GetCredentialsCredentialsCredentialIdGetData,
        GetCredentialsCredentialsCredentialIdGetParameters,
        DeepReadonly<TPageParam>,
        GetCredentialsCredentialsCredentialIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetCredentialsCredentialsCredentialIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCredentialsCredentialsCredentialIdGetSchema,
        GetCredentialsCredentialsCredentialIdGetData,
        GetCredentialsCredentialsCredentialIdGetParameters,
        DeepReadonly<TPageParam>,
        GetCredentialsCredentialsCredentialIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCredentialsCredentialsCredentialIdGetData,
        GetCredentialsCredentialsCredentialIdGetParameters
      >
    >;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>
    ): GetCredentialsCredentialsCredentialIdGetData | undefined;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>
    ):
      | OperationInfiniteData<
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetCredentialsCredentialsCredentialIdGetSchema,
              GetCredentialsCredentialsCredentialIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetCredentialsCredentialsCredentialIdGetData,
                    GetCredentialsCredentialsCredentialIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetCredentialsCredentialsCredentialIdGetSchema,
              GetCredentialsCredentialsCredentialIdGetParameters
            >,
            data: GetCredentialsCredentialsCredentialIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>
    ):
      | QueryState<GetCredentialsCredentialsCredentialIdGetData, GetCredentialsCredentialsCredentialIdGetError>
      | undefined;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetCredentialsCredentialsCredentialIdGetData,
            GetCredentialsCredentialsCredentialIdGetParameters
          >,
          GetCredentialsCredentialsCredentialIdGetError
        >
      | undefined;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>
        | ServiceOperationQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetCredentialsCredentialsCredentialIdGetData> | undefined,
        NoInfer<DeepReadonly<GetCredentialsCredentialsCredentialIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetCredentialsCredentialsCredentialIdGetData | undefined;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetCredentialsCredentialsCredentialIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetCredentialsCredentialsCredentialIdGetData,
              GetCredentialsCredentialsCredentialIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetCredentialsCredentialsCredentialIdGetData,
                GetCredentialsCredentialsCredentialIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetCredentialsCredentialsCredentialIdGetData,
          GetCredentialsCredentialsCredentialIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >,
      updater: Updater<
        NoInfer<GetCredentialsCredentialsCredentialIdGetData> | undefined,
        NoInfer<GetCredentialsCredentialsCredentialIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetCredentialsCredentialsCredentialIdGetData | undefined>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCredentialsCredentialsCredentialIdGetSchema,
        GetCredentialsCredentialsCredentialIdGetData,
        TInfinite,
        GetCredentialsCredentialsCredentialIdGetParameters,
        GetCredentialsCredentialsCredentialIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
    ): void;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Credentials
     * @description Retrieves a single credentials by its ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCredentialsCredentialsCredentialIdGetSchema,
            GetCredentialsCredentialsCredentialIdGetData,
            TInfinite,
            GetCredentialsCredentialsCredentialIdGetParameters,
            GetCredentialsCredentialsCredentialIdGetError
          >
    ): number;
    schema: GetCredentialsCredentialsCredentialIdGetSchema;
    types: {
      parameters: GetCredentialsCredentialsCredentialIdGetParameters;
      data: GetCredentialsCredentialsCredentialIdGetData;
      error: GetCredentialsCredentialsCredentialIdGetError;
    };
  };
  /**
   * @summary Update Credentials
   * @description Updates an existing credentials.
   */
  updateCredentialsCredentialsCredentialIdPut: {
    /**
     * @summary Update Credentials
     * @description Updates an existing credentials.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateCredentialsCredentialsCredentialIdPutBody,
        UpdateCredentialsCredentialsCredentialIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateCredentialsCredentialsCredentialIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateCredentialsCredentialsCredentialIdPutBody,
          UpdateCredentialsCredentialsCredentialIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateCredentialsCredentialsCredentialIdPutData,
          UpdateCredentialsCredentialsCredentialIdPutError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateCredentialsCredentialsCredentialIdPutData,
        UpdateCredentialsCredentialsCredentialIdPutError
      >
    >;
    /**
     * @summary Update Credentials
     * @description Updates an existing credentials.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateCredentialsCredentialsCredentialIdPutParameters> | void
    ): ServiceOperationMutationKey<
      UpdateCredentialsCredentialsCredentialIdPutSchema,
      UpdateCredentialsCredentialsCredentialIdPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Credentials
     * @description Updates an existing credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.useMutation({
     *     path: {
     *         credential_id: credentialId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         credential_id: credentialId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateCredentialsCredentialsCredentialIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateCredentialsCredentialsCredentialIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateCredentialsCredentialsCredentialIdPutSchema,
        UpdateCredentialsCredentialsCredentialIdPutData,
        UpdateCredentialsCredentialsCredentialIdPutParameters,
        TVariables,
        OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateCredentialsCredentialsCredentialIdPutData,
      OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Credentials
     * @description Updates an existing credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.useMutation({
     *     path: {
     *         credential_id: credentialId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         credential_id: credentialId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateCredentialsCredentialsCredentialIdPutBody,
        UpdateCredentialsCredentialsCredentialIdPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateCredentialsCredentialsCredentialIdPutSchema,
        UpdateCredentialsCredentialsCredentialIdPutData,
        UpdateCredentialsCredentialsCredentialIdPutParameters,
        TVariables,
        OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateCredentialsCredentialsCredentialIdPutData,
      OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Credentials
     * @description Updates an existing credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateCredentialsCredentialsCredentialIdPutTotal = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateCredentialsCredentialsCredentialIdPutTotal = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             credential_id: credentialId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateCredentialsCredentialsCredentialIdPutBody,
            UpdateCredentialsCredentialsCredentialIdPutData,
            UpdateCredentialsCredentialsCredentialIdPutParameters,
            OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCredentialsCredentialsCredentialIdPutSchema,
            UpdateCredentialsCredentialsCredentialIdPutBody,
            UpdateCredentialsCredentialsCredentialIdPutData,
            UpdateCredentialsCredentialsCredentialIdPutParameters,
            OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Credentials
     * @description Updates an existing credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateCredentialsCredentialsCredentialIdPutPendingMutationVariables = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateCredentialsCredentialsCredentialIdPutMutationData = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 credential_id: credentialId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateCredentialsCredentialsCredentialIdPutData,
        OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
        MutationVariables<
          UpdateCredentialsCredentialsCredentialIdPutBody,
          UpdateCredentialsCredentialsCredentialIdPutParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateCredentialsCredentialsCredentialIdPutBody,
            UpdateCredentialsCredentialsCredentialIdPutData,
            UpdateCredentialsCredentialsCredentialIdPutParameters,
            OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCredentialsCredentialsCredentialIdPutSchema,
            UpdateCredentialsCredentialsCredentialIdPutBody,
            UpdateCredentialsCredentialsCredentialIdPutData,
            UpdateCredentialsCredentialsCredentialIdPutParameters,
            OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateCredentialsCredentialsCredentialIdPutData,
          OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
          MutationVariables<
            UpdateCredentialsCredentialsCredentialIdPutBody,
            UpdateCredentialsCredentialsCredentialIdPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update Credentials
     * @description Updates an existing credentials.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateCredentialsCredentialsCredentialIdPutBody,
            UpdateCredentialsCredentialsCredentialIdPutData,
            UpdateCredentialsCredentialsCredentialIdPutParameters,
            OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateCredentialsCredentialsCredentialIdPutSchema,
            UpdateCredentialsCredentialsCredentialIdPutBody,
            UpdateCredentialsCredentialsCredentialIdPutData,
            UpdateCredentialsCredentialsCredentialIdPutParameters,
            OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Credentials
     * @description Updates an existing credentials.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             credential_id: credentialId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.credentialsService.updateCredentialsCredentialsCredentialIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateCredentialsCredentialsCredentialIdPutBody,
              UpdateCredentialsCredentialsCredentialIdPutData,
              UpdateCredentialsCredentialsCredentialIdPutParameters,
              OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateCredentialsCredentialsCredentialIdPutSchema,
              UpdateCredentialsCredentialsCredentialIdPutBody,
              UpdateCredentialsCredentialsCredentialIdPutData,
              UpdateCredentialsCredentialsCredentialIdPutParameters,
              OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateCredentialsCredentialsCredentialIdPutData,
            UpdateCredentialsCredentialsCredentialIdPutError,
            MutationVariables<
              UpdateCredentialsCredentialsCredentialIdPutBody,
              UpdateCredentialsCredentialsCredentialIdPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateCredentialsCredentialsCredentialIdPutBody,
              UpdateCredentialsCredentialsCredentialIdPutData,
              UpdateCredentialsCredentialsCredentialIdPutParameters,
              OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateCredentialsCredentialsCredentialIdPutSchema,
              UpdateCredentialsCredentialsCredentialIdPutBody,
              UpdateCredentialsCredentialsCredentialIdPutData,
              UpdateCredentialsCredentialsCredentialIdPutParameters,
              OperationError<UpdateCredentialsCredentialsCredentialIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateCredentialsCredentialsCredentialIdPutData,
          UpdateCredentialsCredentialsCredentialIdPutError,
          MutationVariables<
            UpdateCredentialsCredentialsCredentialIdPutBody,
            UpdateCredentialsCredentialsCredentialIdPutParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateCredentialsCredentialsCredentialIdPutSchema;
    types: {
      parameters: UpdateCredentialsCredentialsCredentialIdPutParameters;
      data: UpdateCredentialsCredentialsCredentialIdPutData;
      error: UpdateCredentialsCredentialsCredentialIdPutError;
      body: UpdateCredentialsCredentialsCredentialIdPutBody;
    };
  };
  /**
   * @summary Delete Credentials
   * @description Deletes an credentials by its ID.
   */
  deleteCredentialsCredentialsCredentialIdDelete: {
    /**
     * @summary Delete Credentials
     * @description Deletes an credentials by its ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteCredentialsCredentialsCredentialIdDeleteBody,
        DeleteCredentialsCredentialsCredentialIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteCredentialsCredentialsCredentialIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteCredentialsCredentialsCredentialIdDeleteBody,
          DeleteCredentialsCredentialsCredentialIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteCredentialsCredentialsCredentialIdDeleteData,
          DeleteCredentialsCredentialsCredentialIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteCredentialsCredentialsCredentialIdDeleteData,
        DeleteCredentialsCredentialsCredentialIdDeleteError
      >
    >;
    /**
     * @summary Delete Credentials
     * @description Deletes an credentials by its ID.
     */
    getMutationKey(
      parameters: DeepReadonly<DeleteCredentialsCredentialsCredentialIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteCredentialsCredentialsCredentialIdDeleteSchema,
      DeleteCredentialsCredentialsCredentialIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete Credentials
     * @description Deletes an credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.useMutation({
     *     path: {
     *         credential_id: credentialId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         credential_id: credentialId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteCredentialsCredentialsCredentialIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteCredentialsCredentialsCredentialIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteCredentialsCredentialsCredentialIdDeleteSchema,
        DeleteCredentialsCredentialsCredentialIdDeleteData,
        DeleteCredentialsCredentialsCredentialIdDeleteParameters,
        TVariables,
        OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteCredentialsCredentialsCredentialIdDeleteData,
      OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete Credentials
     * @description Deletes an credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.useMutation({
     *     path: {
     *         credential_id: credentialId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         credential_id: credentialId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteCredentialsCredentialsCredentialIdDeleteBody,
        DeleteCredentialsCredentialsCredentialIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteCredentialsCredentialsCredentialIdDeleteSchema,
        DeleteCredentialsCredentialsCredentialIdDeleteData,
        DeleteCredentialsCredentialsCredentialIdDeleteParameters,
        TVariables,
        OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteCredentialsCredentialsCredentialIdDeleteData,
      OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete Credentials
     * @description Deletes an credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteCredentialsCredentialsCredentialIdDeleteTotal = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteCredentialsCredentialsCredentialIdDeleteTotal = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             credential_id: credentialId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteCredentialsCredentialsCredentialIdDeleteBody,
            DeleteCredentialsCredentialsCredentialIdDeleteData,
            DeleteCredentialsCredentialsCredentialIdDeleteParameters,
            OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteCredentialsCredentialsCredentialIdDeleteSchema,
            DeleteCredentialsCredentialsCredentialIdDeleteBody,
            DeleteCredentialsCredentialsCredentialIdDeleteData,
            DeleteCredentialsCredentialsCredentialIdDeleteParameters,
            OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete Credentials
     * @description Deletes an credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteCredentialsCredentialsCredentialIdDeletePendingMutationVariables = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteCredentialsCredentialsCredentialIdDeleteMutationData = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 credential_id: credentialId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteCredentialsCredentialsCredentialIdDeleteData,
        OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
        MutationVariables<
          DeleteCredentialsCredentialsCredentialIdDeleteBody,
          DeleteCredentialsCredentialsCredentialIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteCredentialsCredentialsCredentialIdDeleteBody,
            DeleteCredentialsCredentialsCredentialIdDeleteData,
            DeleteCredentialsCredentialsCredentialIdDeleteParameters,
            OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteCredentialsCredentialsCredentialIdDeleteSchema,
            DeleteCredentialsCredentialsCredentialIdDeleteBody,
            DeleteCredentialsCredentialsCredentialIdDeleteData,
            DeleteCredentialsCredentialsCredentialIdDeleteParameters,
            OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteCredentialsCredentialsCredentialIdDeleteData,
          OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
          MutationVariables<
            DeleteCredentialsCredentialsCredentialIdDeleteBody,
            DeleteCredentialsCredentialsCredentialIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Delete Credentials
     * @description Deletes an credentials by its ID.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteCredentialsCredentialsCredentialIdDeleteBody,
            DeleteCredentialsCredentialsCredentialIdDeleteData,
            DeleteCredentialsCredentialsCredentialIdDeleteParameters,
            OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteCredentialsCredentialsCredentialIdDeleteSchema,
            DeleteCredentialsCredentialsCredentialIdDeleteBody,
            DeleteCredentialsCredentialsCredentialIdDeleteData,
            DeleteCredentialsCredentialsCredentialIdDeleteParameters,
            OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete Credentials
     * @description Deletes an credentials by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             credential_id: credentialId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.credentialsService.deleteCredentialsCredentialsCredentialIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteCredentialsCredentialsCredentialIdDeleteBody,
              DeleteCredentialsCredentialsCredentialIdDeleteData,
              DeleteCredentialsCredentialsCredentialIdDeleteParameters,
              OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteCredentialsCredentialsCredentialIdDeleteSchema,
              DeleteCredentialsCredentialsCredentialIdDeleteBody,
              DeleteCredentialsCredentialsCredentialIdDeleteData,
              DeleteCredentialsCredentialsCredentialIdDeleteParameters,
              OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteCredentialsCredentialsCredentialIdDeleteData,
            DeleteCredentialsCredentialsCredentialIdDeleteError,
            MutationVariables<
              DeleteCredentialsCredentialsCredentialIdDeleteBody,
              DeleteCredentialsCredentialsCredentialIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteCredentialsCredentialsCredentialIdDeleteBody,
              DeleteCredentialsCredentialsCredentialIdDeleteData,
              DeleteCredentialsCredentialsCredentialIdDeleteParameters,
              OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteCredentialsCredentialsCredentialIdDeleteSchema,
              DeleteCredentialsCredentialsCredentialIdDeleteBody,
              DeleteCredentialsCredentialsCredentialIdDeleteData,
              DeleteCredentialsCredentialsCredentialIdDeleteParameters,
              OperationError<DeleteCredentialsCredentialsCredentialIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteCredentialsCredentialsCredentialIdDeleteData,
          DeleteCredentialsCredentialsCredentialIdDeleteError,
          MutationVariables<
            DeleteCredentialsCredentialsCredentialIdDeleteBody,
            DeleteCredentialsCredentialsCredentialIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteCredentialsCredentialsCredentialIdDeleteSchema;
    types: {
      parameters: DeleteCredentialsCredentialsCredentialIdDeleteParameters;
      data: DeleteCredentialsCredentialsCredentialIdDeleteData;
      error: DeleteCredentialsCredentialsCredentialIdDeleteError;
      body: DeleteCredentialsCredentialsCredentialIdDeleteBody;
    };
  };
}
/**
 * @summary Create Credentials
 * @description Creates a new credentials.
 */
export const createCredentialsCredentialsPost = {
  schema: {
    method: 'post',
    url: '/credentials',
    mediaType: ['application/json'],
  },
} as {
  schema: CreateCredentialsCredentialsPostSchema;
  [QraftServiceOperationsToken]: CredentialsService['createCredentialsCredentialsPost'];
};
/**
 * @summary Get All Credentialss
 * @description Retrieves a list of credentials with pagination.
 */
export const getAllCredentialssCredentialsGet = {
  schema: {
    method: 'get',
    url: '/credentials',
  },
} as {
  schema: GetAllCredentialssCredentialsGetSchema;
  [QraftServiceOperationsToken]: CredentialsService['getAllCredentialssCredentialsGet'];
};
/**
 * @summary Get Credentials
 * @description Retrieves a single credentials by its ID.
 */
export const getCredentialsCredentialsCredentialIdGet = {
  schema: {
    method: 'get',
    url: '/credentials/{credential_id}',
  },
} as {
  schema: GetCredentialsCredentialsCredentialIdGetSchema;
  [QraftServiceOperationsToken]: CredentialsService['getCredentialsCredentialsCredentialIdGet'];
};
/**
 * @summary Update Credentials
 * @description Updates an existing credentials.
 */
export const updateCredentialsCredentialsCredentialIdPut = {
  schema: {
    method: 'put',
    url: '/credentials/{credential_id}',
    mediaType: ['application/json'],
  },
} as {
  schema: UpdateCredentialsCredentialsCredentialIdPutSchema;
  [QraftServiceOperationsToken]: CredentialsService['updateCredentialsCredentialsCredentialIdPut'];
};
/**
 * @summary Delete Credentials
 * @description Deletes an credentials by its ID.
 */
export const deleteCredentialsCredentialsCredentialIdDelete = {
  schema: {
    method: 'delete',
    url: '/credentials/{credential_id}',
  },
} as {
  schema: DeleteCredentialsCredentialsCredentialIdDeleteSchema;
  [QraftServiceOperationsToken]: CredentialsService['deleteCredentialsCredentialsCredentialIdDelete'];
};
export const credentialsService = {
  createCredentialsCredentialsPost,
  getAllCredentialssCredentialsGet,
  getCredentialsCredentialsCredentialIdGet,
  updateCredentialsCredentialsCredentialIdPut,
  deleteCredentialsCredentialsCredentialIdDelete,
} as const;
type CreateCredentialsCredentialsPostSchema = {
  method: 'post';
  url: '/credentials';
  mediaType: ['application/json'];
};
type CreateCredentialsCredentialsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateCredentialsCredentialsPostData =
  paths['/credentials']['post']['responses']['201']['content']['application/json'];
type CreateCredentialsCredentialsPostError =
  paths['/credentials']['post']['responses']['422']['content']['application/json'];
type CreateCredentialsCredentialsPostBody = paths['/credentials']['post']['requestBody']['content']['application/json'];
type GetAllCredentialssCredentialsGetSchema = {
  method: 'get';
  url: '/credentials';
};
type GetAllCredentialssCredentialsGetParameters = paths['/credentials']['get']['parameters'];
type GetAllCredentialssCredentialsGetData =
  paths['/credentials']['get']['responses']['200']['content']['application/json'];
type GetAllCredentialssCredentialsGetError =
  paths['/credentials']['get']['responses']['422']['content']['application/json'];
type GetCredentialsCredentialsCredentialIdGetSchema = {
  method: 'get';
  url: '/credentials/{credential_id}';
};
type GetCredentialsCredentialsCredentialIdGetParameters = paths['/credentials/{credential_id}']['get']['parameters'];
type GetCredentialsCredentialsCredentialIdGetData =
  paths['/credentials/{credential_id}']['get']['responses']['200']['content']['application/json'];
type GetCredentialsCredentialsCredentialIdGetError =
  paths['/credentials/{credential_id}']['get']['responses']['422']['content']['application/json'];
type UpdateCredentialsCredentialsCredentialIdPutSchema = {
  method: 'put';
  url: '/credentials/{credential_id}';
  mediaType: ['application/json'];
};
type UpdateCredentialsCredentialsCredentialIdPutParameters = paths['/credentials/{credential_id}']['put']['parameters'];
type UpdateCredentialsCredentialsCredentialIdPutData =
  paths['/credentials/{credential_id}']['put']['responses']['200']['content']['application/json'];
type UpdateCredentialsCredentialsCredentialIdPutError =
  paths['/credentials/{credential_id}']['put']['responses']['422']['content']['application/json'];
type UpdateCredentialsCredentialsCredentialIdPutBody =
  paths['/credentials/{credential_id}']['put']['requestBody']['content']['application/json'];
type DeleteCredentialsCredentialsCredentialIdDeleteSchema = {
  method: 'delete';
  url: '/credentials/{credential_id}';
};
type DeleteCredentialsCredentialsCredentialIdDeleteParameters =
  paths['/credentials/{credential_id}']['delete']['parameters'];
type DeleteCredentialsCredentialsCredentialIdDeleteData = null;
type DeleteCredentialsCredentialsCredentialIdDeleteError =
  paths['/credentials/{credential_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteCredentialsCredentialsCredentialIdDeleteBody = undefined;
